import '../components/ArtificialIntelligence/artificial-intelligence.css'
import ChooseIndustry from '../components/ArtificialIntelligence/ChooseIndustry';
import CustomSolutions from '../components/ArtificialIntelligence/CustomSolutions';
import Header from "../components/ArtificialIntelligence/Header"

import TransitionPage from '../utils/TransitionPage';

import { Helmet } from 'react-helmet-async';

const ArtificialIntelligence = () => {
  return (
    <>
      <Helmet>
          <title>AI Implementation & Automation | Advante Digital</title>
          <meta name="description" content="Advante Digital helps companies apply AI where it improves real operations: software delivery, internal workflows, support, data and document processing, and product features backed by human review and controlled deployment powered by Motionode."/>
          <meta name='keywords' content='AI implementation, AI automation, AI-assisted software delivery, workflow automation, document processing, support assistants, Motionode'/>  
      </Helmet>
        <Header />
        <CustomSolutions />
        <ChooseIndustry />
    </>
  );
}

export default TransitionPage ( ArtificialIntelligence );